import api from "../../Services/api";

export const createExel = async (formJsonSchema) => {
  try {
    const response = await api.post("/exels/create", formJsonSchema);
    return response.data;
  } catch (error) {
    console.error("Error sending exel schema:", error);
    throw error;
  }
};

export const fetchForms = async () => {
  try {
    const response = await api.get("/forms/all", {
      data: {},
    });

    return response.data.forms.filter((form) => !form.softDelete);
  } catch (error) {
    console.error("Error fetching forms:", error);
    throw error;
  }
};
